<template>
  <dd-form-page
      :loading="loadingGenericPage"
      submit-route="insurance.storeSinglePolicy" @submit="onSubmit" :header="pageHeader">
    <template #steps>
      <dd-step title="Pakket Gegevens">
        <template v-if="!loadingGenericPage">
          <template v-if="isEditing">
            <Details v-if="editPageLoaded"></Details>
          </template>
          <template v-else>
            <Details></Details>
          </template>
        </template>
      </dd-step>
    </template>
  </dd-form-page>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
import Details from './components/Details.vue';
import store from "./store";
import AttachableCategoryTemplateTypeEnum from "../../../enums/AttachableCategoryTemplateTypeEnum";
import genericStore from "../store";

export default {
  name: "PackageCreatePage.vue",
  components: {
    Details,
  },
  computed: {
    customerId() {
      return this.$route.params?.customer;
    },
    packageId() {
      return this.$route.params?.package;
    },
    ...mapGetters(`$_generic_insurance`, {
      form: 'form',
      viewOptions: 'viewOptions',
      isEditing: 'isEditing',
         loadingGenericPage       : 'loadingPage',
    }),
    ...mapState(`$_generic_insurance`, {
      policy: 'policy',
    }),
    ...mapState(`$_generic_insurance`, {
      policy: 'policy',
    }),
    ...mapState(`$_package_create_or_edit`, {
      editPageLoaded: 'editPageLoaded',
    }),
    pageHeader() {
      let action = this.isEditing ? 'bewerken' : 'aanmaken';
      // Packages are already prefixed with "Pakket{...}"
      return  this.policy ? ` ${this.policy.name} ${action}`: `Pakket ${action}`;
    }
  },
  beforeCreate() {
    if (!('$_generic_insurance' in this.$store._modules.root._children)) {
      this.$store.registerModule('$_generic_insurance', genericStore)
    }
    const STORE_KEY = '$_package_create_or_edit'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  created() {
    this.setCategory({id: AttachableCategoryTemplateTypeEnum.INSURANCE, name: 'Polissen'});
    this.setCustomerId(this.customerId);
    if (this.packageId) {
      this.setPolicyId(this.packageId);
      this.getPolicy();
      this.getInitialPackageEditPageData();
    }
    // Default package view group
    this.setForm({...this.form, view_group_id: 78})
    this.getInitialCreateOrEditPageData();
    this.setIsPackage(true);
  },
  methods: {
    ...mapMutations({
      setCategory: 'SET_CATEGORY',
    }),
    ...mapMutations(`$_generic_insurance`, {
      setCustomerId: 'SET_CUSTOMER_ID',
      setIsPackage: 'SET_IS_PACKAGE',
      clearForm: 'CLEAR_FORM',
      setPackageId: 'SET_PACKAGE_ID',
      setPolicyId: 'SET_POLICY_ID',
      setForm: 'SET_FORM',
    }),
    ...mapActions(`$_package_create_or_edit`, {
      getInitialPackageEditPageData: 'getInitialPackageEditPageData',
    }),
    ...mapActions(`$_generic_insurance`, {
      getInitialCreateOrEditPageData: 'getInitialCreateOrEditPageData',
      getPolicy: 'getPolicy',
      savePolicy: 'savePolicy',
    }),
    ...mapGetters(`$_form_page`, {
      errorObjects: 'errorsObject',
    }),
    onSubmit() {
      this.savePolicy();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
